var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-row',{staticClass:"pb-05 pt-05 border-bottom-thin-solid"},[[_c('f7-col',[_vm._v(_vm._s(_vm.source.command))]),_c('f7-col',[_vm._v(_vm._s(_vm.source.number))]),_c('f7-col',{staticClass:"text-align-right"},[_vm._v(_vm._s(_vm.source.point))]),_c('f7-col',{staticClass:"text-align-right"},[_vm._v(_vm._s(_vm.source.over_point))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }